import { SelectionGroupOption } from 'common/components';
import { DESIGN_IMAGE_LIST_PRESET } from './design-style';
import { LOFT_IMAGE_LIST_PRESET } from './loft-style';
import { MODERN_IMAGE_LIST_PRESET } from './modern-style';
import { NATURE_IMAGE_LIST_PRESET } from './nature-style';
import { NEO_IMAGE_LIST_PRESET } from './neo-style';
import { SCAND_IMAGE_LIST_PRESET } from './scand-style';
import { ImagePreset } from './new-bathroom-gallery-types';

export const ALL_IMAGE_LIST_PRESET: ImagePreset[] = [
  ...SCAND_IMAGE_LIST_PRESET,
  ...NATURE_IMAGE_LIST_PRESET,
  ...MODERN_IMAGE_LIST_PRESET,
  ...LOFT_IMAGE_LIST_PRESET,
  ...DESIGN_IMAGE_LIST_PRESET,
  ...NEO_IMAGE_LIST_PRESET,
];

export const SELECTION_GROUP_LIST: SelectionGroupOption[] = [
  { text: 'Все', value: 'all' },
  { text: 'Скандинавский стиль', value: 'scand' },
  { text: 'Природный стиль', value: 'nature' },
  { text: 'Современный стиль', value: 'modern' },
  { text: 'Лофт', value: 'loft' },
  { text: 'Дизайнерский стиль', value: 'design' },
  { text: 'Неоклассика', value: 'neo' },
];
